import { calcFontSize, calcLongestString, clamp, dateOrText } from "./utils";

export default class ChapteredVideo {
  constructor({ appendTo, chapters, onChapterChange, onSceneChange }) {
    // where to attach the component to
    this.$root = $(appendTo);

    // the data
    this.chapters = chapters;
    this.DOMChapters = {};

    // our callback for invoking video etc.
    this.onChapterChange = onChapterChange;
    this.onSceneChange = onSceneChange;

    // keeping track of where we are
    this.id = this.chapter = 0;

    // give this context to our callback functions
    // this._onChapterClick = this._onChapterClick.bind(this);
    this._onContentClick = this._onContentClick.bind(this);
    this._resize = this._resize.bind(this);

    this._init();
  }

  _calcElementsDim() {
    // content width should be dynamically computed
    const contentWidth = 250;
    // const sideMargins = 300;
    const sideMargins = window.innerWidth * 0.1;
    // maxChapterW  = 200 // apply max width later?

    const contentOrientation = `vertical`;

    const minFontSize = 8;
    const maxFontSize = 18;

    const chaptersNum = this.chapters.length;
    const contentMax =
      contentOrientation === `vertical`
        ? 1
        : Math.max.apply(
            null,
            this.chapters.map((chapter) => chapter.content.length)
          );

    const chapterWidth =
      ((window.innerWidth - sideMargins - contentWidth * contentMax) /
        chaptersNum) *
      0.9; // account for margins between buttons

    const moduleWidth =
      (window.innerWidth - sideMargins) / (chaptersNum + contentMax);

    const titleLongestString = calcLongestString(
      this.chapters.map((chapter) => chapter.name.length)
    );
    const titleFontSize = clamp(
      calcFontSize(moduleWidth, titleLongestString),
      minFontSize,
      maxFontSize
    );
    const subtitleFontSize = clamp(
      Math.round(titleFontSize * 0.6),
      minFontSize,
      maxFontSize
    );

    return {
      chapterWidth: `${chapterWidth}px`,
      // contentWidth: `${contentWidth}px`,
      moduleWidth: moduleWidth, // used for button and content, separate them?
      titleFontSize,
      subtitleFontSize, // for now
      contentTitleFontSize: Math.round(0.9 * titleFontSize),
      contentTextFontSize: Math.round(0.7 * titleFontSize),
    };
  }

  _initChapters() {
    const $wrapper = $("<div/>").attr("class", "chapter-index");

    this.$root.append($wrapper);

    for (let i = 0; i < this.chapters.length; i++) {
      const id = i;
      const chapter = this.chapters[i];

      const $item = $("<div/>")
        .attr("data-chapter", id)
        .attr("class", `chapter-index__item`);

      $wrapper.append($item);

      // store the relevant DOM element
      this.DOMChapters[id] = $item.get(0);

      // do we need to render this element?
      const { inIndex } = this.chapters[i];
      if (!inIndex) {
        this.DOMChapters[id].style.display = "none";
        continue;
      }

      const $button = $("<div/>")
        .attr("data-chapter", id)
        .attr("class", `chapter-index__button`);

      $item.append($button);
      $button.get(0).addEventListener("click", this.onChapterChange);

      // add an element for any content children if needed;
      const $childContainer =
        chapter.content?.length &&
        $("<div/>").attr("class", `chapter-index__content-container`);
      chapter.content?.length && $item.append($childContainer);

      const $chapterTitle = $("<div/>")
        .attr("class", `chapter-index__button-title`)
        .html(chapter.name);

      const $chapterSubTitle = $("<div/>")
        .attr("class", `chapter-index__button-subtitle`)
        .html(dateOrText(chapter.subtitle));

      $button.append($chapterTitle);
      $button.append($chapterSubTitle);

      // chapter content
      for (let j = 0; j < chapter.content.length; j++) {
        const content = chapter.content[j];
        // add a vertical partition

        // add partition
        $childContainer.append(
          $("<div/>").attr("class", "chapter-index__partition")
        );

        const $content = $("<div/>")
          .attr("data-chapter", id)
          .attr("data-section", j)
          .attr("class", "chapter-index__content");

        $childContainer.append($content);
        $content.get(0).addEventListener("click", this.onSceneChange);

        // inside the chapter content div

        // title
        $content.append(
          $("<div/>")
            .attr("class", "chapter-content-title")
            .html(`/ ${content.title}`)
        );

        // text
        $content.append(
          $("<div/>").attr("class", "chapter-content-text").html(content.text)
        );
      }
    }
    this._updateCSSVariables();
  }

  _updateCSSVariables() {
    const selectorPropertyMap = [
      {
        selector: ".chapter-index__button",
        attribute: "--buttonWidth",
        value: this.styleSettings.moduleWidth,
      },
      {
        selector: ".chapter-index__button-title",
        attribute: "--titleFontSize",
        value: this.styleSettings.titleFontSize,
      },
      {
        selector: ".chapter-index__button-subtitle",
        attribute: "--subtitleFontSize",
        value: this.styleSettings.subtitleFontSize,
      },
      {
        selector: ".chapter-index__content",
        attribute: "--contentWidth",
        value: this.styleSettings.moduleWidth * 0.8, // only for now, we can't have a transition if the width is auto
      },
      {
        selector: ".chapter-content-title",
        attribute: "--contentTitleFontSize",
        value: this.styleSettings.contentTitleFontSize,
      },
      {
        selector: ".chapter-content-text",
        attribute: "--contentTextFontSize",
        value: this.styleSettings.contentTextFontSize,
      },
    ];

    selectorPropertyMap.forEach(({ selector, attribute, value }) => {
      document.querySelectorAll(selector).forEach((element) => {
        element.style.setProperty(attribute, `${value}px`);
      });
    });
  }

  _resize() {
    this.styleSettings = this._calcElementsDim();
    this._updateCSSVariables();
  }

  _addResizeEventListeners() {
    window.addEventListener("resize", () => {
      this._resize();
    });

    window.addEventListener("orientationchange", () => {
      this._resize();
    });
  }

  _init() {
    this._addResizeEventListeners();
    this._resize();
    this._initChapters();
  }

  _onContentClick() {}

  updateSelectedChapter(id) {
    /*
  This function is triggered either by clicking on a chapter directly,
  or by the *PLAYER* reaching the starting time of a chapter
  --> this function keeps running as long as the player is on, need to change that, add a listener?
  */

    Object.keys(this.DOMChapters).forEach((id) => {
      this.DOMChapters[id].classList.remove("chapter-index__item--selected");
    });

    this.DOMChapters[id].classList.add("chapter-index__item--selected");
  }

  resize() {}
}
